import gql from "graphql-tag";
import apolloGetQuery from "application/apollo/apolloGetQuery";
import apolloGetMutation from "application/apollo/apolloGetMutation";
import getSearchToken from "application/queries/searchToken";
import getSearchForm from "application/queries/searchForm";

const searchToken = (id, headers) => apolloGetQuery({
  query: gql`
    {
      ${getSearchToken(id)}
    }
  `,
}, headers);

  const searchForm = (id, headers) => apolloGetQuery({
    query: gql`
      {
        ${getSearchForm(id)}
      }
    `,
  }, headers);

  const createForm = (content, headers) => apolloGetMutation({
    mutation: gql`
      mutation createContent($content: ContentInput!) {
        content(content: $content) {
          id,
        }
      }
    `,
    variables: content,
  }, headers);

export default {
  searchToken,
  searchForm,
  createForm
};
